<template>
  <div class="notFound">页面不存在</div>
</template>

<script>
export default {
  name: "Home",
  components: {},
  data() {
    return {};
  },

  mounted() {},
  methods: {},
};
</script>
<style scoped lang="less">
@import "./index.less";
</style>
